import { injectIntl } from 'react-intl';

import { i18nKeys } from '@gloat/glocalize';

type ListToReadableStringProps = { intl?: any; list?: string[]; bailTranslation?: boolean; endKey?: 'or' | 'and' };
const listToReadableStringWithoutIntl = ({
  intl,
  list = [],
  endKey = 'or',
  bailTranslation,
}: ListToReadableStringProps): string => {
  const readableStringArray: string[] = [];

  const endKeysEnum = {
    or: bailTranslation ? 'or' : intl.formatMessage({ id: i18nKeys.OR, defaultMessage: 'or' }),
    and: bailTranslation ? 'and' : intl.formatMessage({ id: i18nKeys.AND, defaultMessage: 'and' }),
  };

  list.forEach((item, index) => {
    const isLast = index === list.length - 1;
    const isFirst = index === 0;

    if (isFirst) {
      readableStringArray.push(item);
    } else if (isLast) {
      readableStringArray.push(` ${endKeysEnum[endKey]} `);
      readableStringArray.push(item);
    } else {
      readableStringArray.push(`, ${item}`);
    }
  });

  return readableStringArray.join('');
};

const listToReadableString = injectIntl(listToReadableStringWithoutIntl) as (
  props: ListToReadableStringProps,
) => string;
export default listToReadableString;
